import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import logger from './logger';
export var buildSelectOptions = function buildSelectOptions(arr, keyMap) {
  try {
    // to avoid full component/page render crashes
    // map method exist only in Array.prototype. This function may fail in case "arr" argument is not an array.
    // In case API server is down or doesnt provide expected data, default [] should be returned and be logged quietly.
    return arr.map(function (item) {
      return {
        key: item[keyMap.key],
        value: item[keyMap.value],
        text: item[keyMap.text],
        name: item[keyMap.name],
        // Can be used for example, in case of icons, or cases where you need "2 texts"
        extrafield1: item[keyMap.extrafield1]
      };
    });
  } catch (e) {
    logger(e);
    return [];
  }
};
export var buildSelectedWithConvertOptions = function buildSelectedWithConvertOptions(obj, keyMap) {
  try {
    return obj.map(function (item) {
      return {
        key: item[keyMap.key],
        value: _parseInt(item[keyMap.value], 10),
        text: item[keyMap.text],
        name: item[keyMap.name]
      };
    });
  } catch (e) {
    logger(e);
    return [];
  }
};
export var getSelectedOption = function getSelectedOption(obj, item) {
  if (item) {
    var parsedObj = obj.find(function (i) {
      return i.text === item;
    });
    return parsedObj ? parsedObj.value : '';
  }

  return '';
};
export var buildSelectWithNoKeyMap = function buildSelectWithNoKeyMap(obj) {
  try {
    return obj.map(function (item) {
      return {
        key: item,
        value: item,
        text: item,
        name: item
      };
    });
  } catch (e) {
    logger(e);
    return [];
  }
};
export var handleNoAutocomplete = function handleNoAutocomplete(event) {
  event.target.setAttribute('autocomplete', 'nope');
};
export var buildTimezoneOptions = function buildTimezoneOptions(arr, keyMap) {
  try {
    return arr.map(function (item) {
      return {
        key: item[keyMap.key],
        value: item[keyMap.value],
        text: "".concat(item[keyMap.shortDisplayName], " (").concat(item[keyMap.currentOffset], ") ").concat(item[keyMap.key]),
        name: item[keyMap.name]
      };
    });
  } catch (e) {
    logger(e);
    return [];
  }
};
export default {};